"use strict";

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2019 Looker Data Sciences, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmbedClient = void 0;
var chatty_1 = require("@looker/chatty");
var IS_URL = /^https?:\/\//;
/**
 * Wrapper for Looker embedded content. Provides a mechanism for creating the embedded content element,
 * and for establishing two-way communication between the parent window and the embedded content.
 */
var EmbedClient = /** @class */function () {
  /**
   * @hidden
   */
  function EmbedClient(_builder) {
    this._builder = _builder;
    this._hostBuilder = null;
    this._host = null;
    this._connection = null;
    this._client = null;
  }
  Object.defineProperty(EmbedClient.prototype, "connection", {
    /**
     * Returns a promise that resolves to a client that can be used to send messages to the
     * embedded content.
     */
    get: function get() {
      return this._connection;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EmbedClient.prototype, "isConnected", {
    /**
     * Indicates whether two way communication has successfully been established with the embedded content.
     */
    get: function get() {
      return !!this._connection;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(EmbedClient.prototype, "targetOrigin", {
    get: function get() {
      if (this._builder.sandboxedHost) {
        return '*';
      }
      var apiHost = this._builder.apiHost;
      return IS_URL.test(apiHost) ? apiHost : "https://" + apiHost;
    },
    enumerable: false,
    configurable: true
  });
  EmbedClient.prototype.createIframe = function (url) {
    return __awaiter(this, void 0, void 0, function () {
      var eventType, _loop_1, this_1, _i, _a, handler, _b, _c, attr;
      var _d;
      var _this = this;
      return __generator(this, function (_e) {
        this._hostBuilder = chatty_1.Chatty.createHost(url);
        for (eventType in this._builder.handlers) {
          _loop_1 = function _loop_1(handler) {
            this_1._hostBuilder.on(eventType, function () {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              return handler.apply(_this._client, args);
            });
          };
          this_1 = this;
          for (_i = 0, _a = this._builder.handlers[eventType]; _i < _a.length; _i++) {
            handler = _a[_i];
            _loop_1(handler);
          }
        }
        for (_b = 0, _c = this._builder.sandboxAttrs; _b < _c.length; _b++) {
          attr = _c[_b];
          this._hostBuilder.withSandboxAttribute(attr);
        }
        this._host = this._hostBuilder
        // tslint:disable-next-line:deprecation
        .frameBorder(this._builder.frameBorder).withTargetOrigin(this.targetOrigin).appendTo(this._builder.el).build();
        // IE doesn't like calling classList.add() with no arguments, so check
        if (this._builder.classNames.length) {
          (_d = this._host.iframe.classList).add.apply(_d, this._builder.classNames);
        }
        return [2 /*return*/, this._host.connect().then(function (host) {
          _this._client = new _this._builder.clientConstructor(host);
          return _this._client;
        })];
      });
    });
  };
  EmbedClient.prototype.createUrl = function () {
    return __awaiter(this, void 0, void 0, function () {
      var src, url;
      var _this = this;
      return __generator(this, function (_a) {
        src = this._builder.embedUrl;
        if (!this._builder.authUrl) return [2 /*return*/, "" + this._builder.apiHost + src];
        url = this._builder.authUrl + "?src=" + encodeURIComponent(src);
        return [2 /*return*/, new Promise(function (resolve, reject) {
          return __awaiter(_this, void 0, void 0, function () {
            var xhr;
            return __generator(this, function (_a) {
              xhr = new XMLHttpRequest();
              xhr.open('GET', url);
              xhr.setRequestHeader('Cache-Control', 'no-cache');
              xhr.onload = function () {
                if (xhr.status === 200) {
                  resolve(JSON.parse(xhr.responseText).url);
                } else {
                  reject(xhr.statusText);
                }
              };
              xhr.onerror = function () {
                return reject(xhr.statusText);
              };
              xhr.send();
              return [2 /*return*/];
            });
          });
        })];
      });
    });
  };
  /**
   * Establish two way communication with embedded content. Returns a promise that resolves to a
   * client that can be used to send messages to the embedded content.
   */
  EmbedClient.prototype.connect = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;
      return __generator(this, function (_a) {
        if (this._connection) return [2 /*return*/, this._connection];
        if (this._builder.url) {
          this._connection = this.createIframe(this._builder.url);
        } else {
          this._connection = this.createUrl().then(function (url) {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2 /*return*/, this.createIframe(url)];
              });
            });
          });
        }
        return [2 /*return*/, this._connection];
      });
    });
  };
  return EmbedClient;
}();
exports.EmbedClient = EmbedClient;